import leaveSvg from "./leave.svg";

import { Button } from "devextreme-react/button";
import "./card.scss";
import "./card-dark.scss";
const DEFAULT = [
  {
    id: 1,
    status: "Approved",
    emp: "BVNe025 - Nguyễn Thị Thanh Ngọc",
    type: "Phép Năm - Annual Leave - Cả ngày",
    date: "29/08/2022 - 29/08/2022",
    reason: `Lorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempeLorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempeLorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempe`,
  },
  {
    id: 2,
    status: "New",
    emp: "BVNe025 - Nguyễn Thị Thanh Ngọc",
    type: "Phép Năm - Annual Leave - Cả ngày",
    date: "29/08/2022 - 29/08/2022",
    reason: `Lorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempeLorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempeLorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempe`,
  },
  {
    id: 3,
    status: "In-progress",
    emp: "BVNe025 - Nguyễn Thị Thanh Ngọc",
    type: "Phép Năm - Annual Leave - Cả ngày",
    date: "29/08/2022 - 29/08/2022",
    reason: `Lorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempeLorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempeLorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempe`,
  },
  {
    id: 4,
    status: "Rejected",
    emp: "BVNe025 - Nguyễn Thị Thanh Ngọc",
    type: "Phép Năm - Annual Leave - Cả ngày",
    date: "29/08/2022 - 29/08/2022",
    reason: `Lorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempeLorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempeLorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempe`,
  },
  {
    id: 5,
    status: "Canceled",
    emp: "BVNe025 - Nguyễn Thị Thanh Ngọc",
    type: "Phép Năm - Annual Leave - Cả ngày",
    date: "29/08/2022 - 29/08/2022",
    reason: `Lorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempeLorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempeLorem Ipsum aretra vel turpis nunc eget lorem dolor sed viverra
        ipsum nunc aliquet bibendum enim facilisis gravida neque convallis a
        cras sempe`,
  },
];
const changeColor = (status) => {
  switch (status) {
    case "Approved":
      return "top-approved-capu";
    case "In-progress":
      return "top-inprogress-capu";
    case "Canceled":
      return "top-canceled-capu";
    case "New":
      return "top-new-capu";
    case "Rejected":
      return "top-rejected-capu";

    default:
      break;
  }
};
export default function Card() {
  return (
    <div className="cards-item-capu mt-3">
      {DEFAULT.map((item) => (
        <div className="card-item-capu" key={item.id}>
          <div className={`card-top-capu ` + changeColor(item.status)}>
            <h2 className="card-title-capu">{item.status}</h2>
          </div>
          <div className="card-content-capu">
            <div className="card-content-top-capu">
              <img src={leaveSvg} alt="" className="card-item-image-capu" />
            </div>
            <div className="card-info-capu">
              <h2 className="employee-name-capu">{item.emp}</h2>
              <p className="type-capu">{item.type}</p>
              <p className="date-capu">{item.date}</p>
              <p className="reason-capu">{item.reason}</p>
            </div>
            <div className="card-footer-capu">
              <Button
                type="default"
                stylingMode="outlined"
                text="Edit"
                className="button-item-capu button-rounded mr-2"
              />
              <Button
                type="danger"
                stylingMode="outlined"
                text="Cancel"
                className="button-item-capu button-rounded"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
